"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ContactForm_1 = require("./ContactForm");
const ApplicationStore_1 = require("../stores/ApplicationStore");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const EntitiesActions_1 = require("../actions/EntitiesActions");
class About extends React.Component {
    render() {
        return (React.createElement("section", { className: 'pt-page pt-page-current', "data-id": 'blog' },
            React.createElement("div", { className: 'section-title-block' },
                React.createElement("h2", { className: 'section-title' }, "Contact"),
                React.createElement("h5", { className: 'section-description' }, "Get in Touch")),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-sm-6 col-md-6 subpage-block' },
                    React.createElement("div", { className: 'block-title' },
                        React.createElement("h3", null, "Get in Touch")),
                    this.props.about &&
                        React.createElement("p", null, this.props.about),
                    this.props.location && React.createElement("div", { className: 'contact-info-block' },
                        React.createElement("div", { className: 'ci-icon' },
                            React.createElement("i", { className: 'pe-7s-icon pe-7s-map-marker' })),
                        React.createElement("div", { className: 'ci-text' },
                            React.createElement("h5", null, this.props.location))),
                    this.props.email && React.createElement("div", { className: 'contact-info-block' },
                        React.createElement("div", { className: 'ci-icon' },
                            React.createElement("i", { className: 'pe-7s-icon pe-7s-mail' })),
                        React.createElement("div", { className: 'ci-text' },
                            React.createElement("h5", null, this.props.email))),
                    this.props.phone && React.createElement("div", { className: 'contact-info-block' },
                        React.createElement("div", { className: 'ci-icon' },
                            React.createElement("i", { className: 'pe-7s-icon pe-7s-call' })),
                        React.createElement("div", { className: 'ci-text' },
                            React.createElement("h5", null, this.props.phone))),
                    this.props.freelance && React.createElement("div", { className: 'contact-info-block' },
                        React.createElement("div", { className: 'ci-icon' },
                            React.createElement("i", { className: 'pe-7s-icon pe-7s-check' })),
                        React.createElement("div", { className: 'ci-text' },
                            React.createElement("h5", null, "Freelance Available")))),
                React.createElement("div", { className: 'col-sm-6 col-md-6 subpage-block' },
                    React.createElement("div", { className: 'block-title' },
                        React.createElement("h3", null, "Contact Form")),
                    React.createElement("p", null, "Contact me for any reason."),
                    React.createElement(ContactForm_1.default, { sendEnquiry: this.props.sendEnquiry })))));
    }
}
exports.default = (0, fluxible_addons_react_1.connectToStores)(About, [ApplicationStore_1.default], (context, props) => {
    return {
        freelance: context.getStore(ApplicationStore_1.default).getParam('freelance') === 'true',
        email: context.getStore(ApplicationStore_1.default).getParam('email'),
        phone: context.getStore(ApplicationStore_1.default).getParam('phone'),
        location: context.getStore(ApplicationStore_1.default).getParam('location'),
        about: context.getStore(ApplicationStore_1.default).getParam('about'),
        sendEnquiry: (request) => context.executeAction(EntitiesActions_1.default.sendEnquiry, request),
    };
});
